import { createGlobalStyle } from 'styled-components';
import ProximaNovaWOFF from '../assets/fonts/proxima-nova-webfont.woff';
import ProximaNovaWOFF2 from '../assets/fonts/proxima-nova-webfont.woff2';

export const GlobalStyle = createGlobalStyle`
  @font-face {
      font-family: 'Proxima Nova';
      src: url(${ProximaNovaWOFF2}) format('woff2'),
          url(${ProximaNovaWOFF}) format('woff');
      font-weight: normal;
      font-style: normal;
  }

  body {
    font-family: 'Proxima Nova';
  }
`;
